import React, { useContext, useState } from 'react';

const GenerateTrackingLinkContext = React.createContext({
  showCreateModal: false,
  setShowCreateModal: () => {},
  showEditModal: '',
  setShowEditModal: () => {},
  showSuccessModal: false,
  setShowSuccessModal: () => {},
  showErrorModal: false,
  setShowErrorModal: () => {},
  showDeleteModal: false,
  setShowDeleteModal: () => {},
  selectedCommissionTier: '',
  setSelectedCommissionTier: () => {},
  showCommissionTierDropdown: null,
  setShowCommissionTierDropdown: () => {},
  isCustomizeLandingPage: '',
  setIsCustomizeLandingPage: () => {},
  productPageLink: '',
  setProductPageLink: () => {},
  generatedLink: '',
  setGeneratedLink: () => {},
  refCode: '',
  setRefCode: () => {},
  selectedReferralLinkId: '',
  setSelectedReferralLinkId: () => {},
  generatedRefLink: false,
  setGeneratedRefLink: () => {},
  disableSubmitButton: false,
  setDisableSubmitButton: () => {},
  errorText: '',
  setErrorText: () => {},
  isDefaultLink: false,
  setIsDefaultLink: () => {},
  partnershipLimitModal: false,
  setPartnershipLimitModal: () => {},
});

const GenerateTrackingLinkContentProvider = ({ children }) => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [selectedCommissionTier, setSelectedCommissionTier] = useState('');
  const [showCommissionTierDropdown, setShowCommissionTierDropdown] = useState(null);
  const [isCustomizeLandingPage, setIsCustomizeLandingPage] = useState('');
  const [productPageLink, setProductPageLink] = useState('');
  const [generatedLink, setGeneratedLink] = useState(''); // for storing ref link for 1st
  const [refCode, setRefCode] = useState('');

  const [selectedReferralLinkId, setSelectedReferralLinkId] = useState('');
  const [generatedRefLink, setGeneratedRefLink] = useState(false); // for storing ref link of other

  const [disableSubmitButton, setDisableSubmitButton] = useState(false);
  const [errorText, setErrorText] = useState('');

  const [partnershipLimitModal, setPartnershipLimitModal] = useState(false);

  // shortLinks
  const [shortLinksStatus, setShortLinkStatus] = useState(false);
  const [shortLinkValue, setShortLinkValue] = useState('');

  const [isDefaultLink, setIsDefaultLink] = useState(false);

  const handleCloseModal = () => {
    setRefCode('');
    setShowCreateModal(false);
    setShowEditModal(false);
    setShowDeleteModal(false);
    setGeneratedLink('');
    setProductPageLink('');
    setGeneratedLink('');
    setSelectedReferralLinkId('');
    setIsDefaultLink(false);
    setDisableSubmitButton(false);
    setIsCustomizeLandingPage(false);
    setShortLinkStatus(false);
    setShortLinkValue('');
  };

  return (
    <GenerateTrackingLinkContext.Provider
      value={{
        showCreateModal,
        setShowCreateModal,
        showEditModal,
        setShowEditModal,
        showSuccessModal,
        setShowSuccessModal,
        showErrorModal,
        setShowErrorModal,
        showDeleteModal,
        setShowDeleteModal,
        selectedCommissionTier,
        setSelectedCommissionTier,
        showCommissionTierDropdown,
        setShowCommissionTierDropdown,
        isCustomizeLandingPage,
        setIsCustomizeLandingPage,
        productPageLink,
        setProductPageLink,
        generatedLink,
        setGeneratedLink,
        refCode,
        setRefCode,
        selectedReferralLinkId,
        setSelectedReferralLinkId,
        generatedRefLink,
        setGeneratedRefLink,
        disableSubmitButton,
        setDisableSubmitButton,
        errorText,
        setErrorText,
        isDefaultLink,
        setIsDefaultLink,
        handleCloseModal,
        shortLinksStatus,
        setShortLinkStatus,
        shortLinkValue,
        setShortLinkValue,
        partnershipLimitModal,
        setPartnershipLimitModal,
      }}>
      {children}
    </GenerateTrackingLinkContext.Provider>
  );
};

export const useGenerateTrackingLinkModal = () => {
  return useContext(GenerateTrackingLinkContext);
};

export default GenerateTrackingLinkContentProvider;
